import { Navigate } from "react-router-dom";
import { useAuth } from "../../features/auth/hooks/useAuth";

// Usado nas rotas de auth (login/signup) — se já houver sessão, redireciona para o
// dashboard em vez de mostrar o formulário de novo.
export default function PublicOnlyRoute({ children }) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
